import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { GetPendingAttributeValuesResponse } from '@/api/handlers/resources/attributeTypes/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { AttributeQueryKeys } from './attributeQueryKeys';

/**
 * Reads the pending-review queue (`GET /attribute-types/pending-values`).
 * Empty until product import (not built yet) starts creating pending values.
 */
export const usePendingAttributeValuesQuery = (enabled = true) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetPendingAttributeValuesResponse>>({
        queryKey: AttributeQueryKeys.pending(),
        queryFn: () => apiClient.attributeTypes.getPendingValues(),
        enabled,
        staleTime: 60_000,
    });
};
